"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import Tooltip from '../../components/Tooltip.sfc';
const popupWidth = () => {
  const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 980;
  return w * 0.8;
};
const popupHeight = () => {
  const h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 900;
  return h * 0.9;
};
class SamlLink extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "closeModal", () => {
      this.setState({
        showModal: false
      });
    });
    _defineProperty(this, "getFieldName", title => {
      if (title.includes('Aggregate View')) {
        return 'menu_va_ca_agg';
      }
      if (title.includes('Sponsor View')) {
        return 'menu_va_ca_ps';
      }
      return '_undefined';
    });
    _defineProperty(this, "openAppModal", () => {
      const {
        providerId,
        title,
        path
      } = this.props;
      _ApplicationContext.ApplicationContext.setContext('samllaunch.title', title);
      _ApplicationContext.ApplicationContext.setContext('samllaunch.providerId', providerId);
      window.open(path, 'samlpopup', `resizable=1,width=${popupWidth()},height=${popupHeight()},scrollbars`);
      this.setState({
        showModal: false
      });
    });
    this.state = {
      showModal: false
    };
    this.submitForm = this.submitForm.bind(this);
    this.el = document.createElement('div');
    this.el.style.display = 'contents';
  }
  componentDidMount() {
    document.body.appendChild(this.el);
  }
  componentWillUnmount() {
    document.body.removeChild(this.el);
  }
  submitForm() {
    this.setState({
      showModal: true
    });
  }
  renderOKModal() {
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_core.Modal, {
      showCloseIcon: true,
      darkBackground: true,
      closeModalCallback: this.closeModal,
      footer: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
        className: "is-primary is-pulled-right fixedButtonSize",
        handleClick: this.openAppModal
      }, "Ok")),
      header: "*ATTENTION*"
    }, /*#__PURE__*/_react.default.createElement("div", null, "Please note that the Visual Analytics tool will be removed from the Consultant Access website in Q3 2022. For your continued reporting needs please reference the expanded reports section of Consultant Access. If you have any questions or concerns contact our team", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: 'mailto:consultantservices@missionsq.org'
    }, "consultantservices@missionsq.org"), ".")), this.el);
  }
  render() {
    var _SecurityContextHolde;
    const {
      title,
      className,
      renderType
    } = this.props;
    const {
      showModal
    } = this.state;
    const superUser = (_SecurityContextHolde = _SecurityContextHolder.SecurityContextHolder.getCurrentContext()) === null || _SecurityContextHolde === void 0 ? void 0 : _SecurityContextHolde.impersonator;
    if (!superUser) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderType === 'button' ? /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.submitForm,
        className: "button is-secondary is-pulled-right"
      }, title) : /*#__PURE__*/_react.default.createElement("a", {
        className: className,
        onClick: this.submitForm
      }, title, ' '), showModal && this.renderOKModal());
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, renderType === 'button' ? /*#__PURE__*/_react.default.createElement("button", {
      className: "button is-secondary is-pulled-right"
    }, title) : /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      className: className
    }, title, ' '));
  }
}
exports.default = SamlLink;
SamlLink.propTypes = {
  providerId: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  renderType: _propTypes.default.string,
  path: _propTypes.default.string
};
SamlLink.defaultProps = {
  className: ''
};
//# sourceMappingURL=SamlLink.js.map